var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicMdClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9961 2.1L18.8961 0L10.5191 8.381L2.13809 0.00399971L0.0380859 2.104L8.41909 10.481L0.0420856 18.862L2.14209 20.962L10.5191 12.581L18.9001 20.962L21.0001 18.862L12.6191 10.481L20.9961 2.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicMdClose);
export default __webpack_public_path__ + "static/media/ionic-md-close.14fb45433d79a6a6fccd696e02359a51.svg";
export { ForwardRef as ReactComponent };